import { createEvent, createStore } from 'effector';
import { KeycloakTokenParsed } from 'keycloak-js';

export interface User extends KeycloakTokenParsed {
  groups?: string[];
  email?: string;
  num?: string | null;
  firstname?: string;
  secondname?: string;
  middlename?: string;
  phone?: string | null;
}

export const setUser = createEvent<User>();
export const resetUser = createEvent();

export const $user = createStore<User | null>(null)
  .on(setUser, (_, user) => user)
  .reset(resetUser);
